import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
// import logoCircle from '../../assets/images/logo-icon.png';

const VersionModal = () => {
  const [open, setOpen] = useState(false);
  // const [htmlContent, setHtmlContent] = useState<string>('');

  // const handleOpen = async () => {
  //   setOpen(true);
  //   // Carrega o HTML localmente
  //   const response = await fetch('./versions/test.html');
  //   console.log(response);
  //   const text1 = await response.text();
  //   console.log(text1);
  //   const text = '<h1>Juma Entregas - Versão 0.45.0</h1>'; // await response.text();
  //   console.log(text);
  //   setHtmlContent(text);
  // };

  const handleClose = () => setOpen(false);

  return (
    <>
      {/* <button type="button" onClick={handleOpen}>Abrir Novidades</button> */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            maxHeight: '80vh',
            overflowY: 'auto',
            minWidth: 850
          }}
        >
          {/* <div dangerouslySetInnerHTML={{ __html: htmlContent }} /> */}
        </Box>
      </Modal>
    </>
  );
};

export default VersionModal;
